import theme from '@clarity-website/utils/theme';
import { ThemeProvider } from 'styled-components';

type Props = { children: JSX.Element };

export default function ClarityThemeProvider({ children }: Props) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
